import Breadcrumb from "../../components/Breadcrumb/Breadcrumb.js";
import TournamentResultsWrapper from "../../components/TournamentResults/TournamentResultsWrapper.js";

import { useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";

export default function Results() {
  const tournamentSlug = useTournamentSlug();

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments", path: "/tournaments" },
    { label: "[Tournament Name]", path: tournamentPath(tournamentSlug) },
    { label: "Standings" },
  ];

  return (
    <>
      <div className="flex justify-center mb-3 sm:mb-4 px-4 sm:px-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <TournamentResultsWrapper />
    </>
  );
}
